import { asPlaybookId } from "@repo/app-types/entities/playbook";
import { asTeammateId } from "@repo/app-types/entities/teammate";
import type { FC } from "react";
import { useParams } from "react-router";
import { NavigationSlideoverContainer } from "../../hooks/useModalNavigation.js";
import {
  useAgentPlaybookFilterDefaults,
  usePlaybookFilterDefaults,
} from "../filters/usePlaybookFilterDefaults.js";
import { CriterionDialog } from "./criterionDialog.js";

interface TrainingTeammatePagePlaybookCriterionProps {
  /**
   * Whether the pages this drilldown opens over default to excluding calls
   * without grades. The agents workspace does not, so the dialog must not
   * either — it would count a different population than the page behind it.
   */
  appliesHasResultDefault: boolean;
}

export const TrainingTeammatePagePlaybookCriterion: FC<
  TrainingTeammatePagePlaybookCriterionProps
> = ({ appliesHasResultDefault }) => {
  const {
    playbookId: playbookIdParam,
    teammateId: teammateIdParam,
    criterionId,
  } = useParams();
  if (!playbookIdParam || !teammateIdParam || !criterionId) {
    throw new Error("Missing params.");
  }

  const playbookId = asPlaybookId(playbookIdParam);
  const teammateId = asTeammateId(teammateIdParam);
  const playbookFilterDefaults = usePlaybookFilterDefaults(playbookId, "team");
  const agentFilterDefaults = useAgentPlaybookFilterDefaults(
    playbookId,
    "team",
  );
  const filterDefaults = appliesHasResultDefault
    ? playbookFilterDefaults
    : agentFilterDefaults;

  return (
    <>
      <CriterionDialog
        playbookId={playbookId}
        teammateId={teammateId}
        criterionId={criterionId}
        filterDefaults={filterDefaults}
      />
      <NavigationSlideoverContainer />
    </>
  );
};
